<wuc-explanation-arrow
    type="primary"
    fontSize="normal"
    [position]="arrowRight ? 'topRight' : 'topLeft'"
    [text]="arrowText"
>
    <wuc-drop-trigger>
        <wuc-button e2e="dropdown-calculate-premium-buttons">Bereken nu uw premie</wuc-button>
        <wuc-balloon arrowPosition="topLeft" padding="large">
            <ins-insurances-list></ins-insurances-list>
        </wuc-balloon>
    </wuc-drop-trigger>
</wuc-explanation-arrow>
